export default __webpack_public_path__ + "static/media/product4.e6699577.jpg";